/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getOccupationQuestionnaireTable = params => {
  return axios.post(`${base}/occupation/questionnaire/query`, params)
}
export const getOccupationQuestionnaireDetail = params => {
  return axios.get(`${base}/occupation/questionnaire/get_${params.id}`, {params})
}
export const previewOccupationQuestionnaire = params => {
  return axios.get(`${base}/occupation/questionnaire/preview_${params.id}`, {params})
}
export const createOccupationQuestionnaireData = params => {
  return axios.post(`${base}/occupation/questionnaire/create`, params)
}
export const updateOccupationQuestionnaireData = params => {
  return axios.post(`${base}/occupation/questionnaire/edit_${params.id}`, params)
}
export const setOccupationQuestionnaireStatus = params => {
  return axios.post(`${base}/occupation/questionnaire/set_status_${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/occupation-questionnaire/occupation-questionnaire.api.js